import React, { useEffect } from 'react';
import { useData } from '../context/DataContext';
import { isPrerender } from '../utils/isPrerender';
import Seo from './Seo';
import SectionTitle from './SectionTitle';

const Joueurs = () => {
  const { joueurs, joueursLoading, joueursError, fetchJoueurs } = useData();

  useEffect(() => {
    if (isPrerender()) return;
    fetchJoueurs();
  }, [fetchJoueurs]);

  if (joueursError) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <strong>Erreur:</strong> {joueursError}
          <button
            className="btn btn-sm btn-outline-danger ms-2"
            onClick={() => fetchJoueurs(true)}
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  // Vérification supplémentaire pour éviter l'erreur
  const joueursArray = Array.isArray(joueurs) ? joueurs : [];

  return (
    <div className="container container-joueurs">
      <Seo
        path="/joueurs"
        title="Classement des joueurs"
        description="Classement officiel FFTT des licenciés du Tennis de Table Briançon, par nombre de points."
      />
      <SectionTitle as="h1" overline="Licenciés">
        Classement des joueurs
      </SectionTitle>

      <p className="page-intro">
        Retrouvez le classement des licenciés du club, trié par nombre de points
        officiels de la Fédération Française de Tennis de Table (FFTT). Les points
        évoluent au fil des rencontres : victoires et défaites font monter ou
        baisser chaque joueur selon la valeur de l'adversaire. Le tableau
        ci-dessous est mis à jour automatiquement à partir des données de la
        fédération.
      </p>

      {joueursLoading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : joueursArray.length === 0 ? (
        <p className="page-empty">Aucun joueur à afficher pour le moment.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Nom</th>
                <th scope="col">Prénom</th>
                <th scope="col">Points</th>
              </tr>
            </thead>
            <tbody>
              {joueursArray.map((joueur, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{joueur.nom}</td>
                  <td>{joueur.prenom}</td>
                  <td><strong>{joueur.points}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Joueurs;
